import { TableHeader } from "@/models/TableHeader";

export const blacklistHeaders: TableHeader[] = [
  {
    text: "Location Code",
    value: "location_code"
  },
  {
    text: "Tenant",
    value: "customer_name"
  },
  {
    text: "Email",
    value: "email_address"
  },
  {
    text: "Phone #",
    value: "phone_number"
  },
  {
    text: "Drivers License #",
    value: "drivers_license_number"
  },
  {
    text: "Date Created",
    value: "created_at"
  },
  {
    text: "Note",
    value: "note"
  },
  {
    text: "Actions...",
    value: "actions",
    sortable: false
  }
];
